export enum EGeoType {
  /** Страна **/
  Country = 'country',
  /** Локация **/
  Location = 'location',
  /** Улица **/
  Street = 'street',
  /** Шоссе **/
  Road = 'road',
  /** Район **/
  District = 'district',
  /** Метро **/
  Underground = 'underground',
  /** Дом **/
  House = 'house',
}
